module.exports = __webpack_public_path__ + "img/bioseguridad.20f6f472.svg";